import { apiClient } from './client'

export interface ExchangeRates {
  USD: number
  EUR: number
  CNY: number
  updatedAt: string | null
  /** Дата последнего обновления per-currency. null если значение по дефолту (нет записи в БД). */
  updatedAtByCurrency: { USD: string | null; EUR: string | null; CNY: string | null }
}

export async function getExchangeRates(): Promise<ExchangeRates> {
  const res = await apiClient.get<{ success: boolean; data: ExchangeRates }>('/exchange-rates')
  return res.data.data
}

export async function putExchangeRates(
  rates: Partial<Record<'USD' | 'EUR' | 'CNY', number>>,
): Promise<ExchangeRates> {
  const res = await apiClient.put<{ success: boolean; data: ExchangeRates }>(
    '/exchange-rates',
    rates,
  )
  return res.data.data
}

// ── История курсов (этап 3, C2) ──────────────────────────────

export type RateCurrency = 'USD' | 'EUR' | 'CNY'

export interface RateHistoryEntry {
  id: string
  currency: RateCurrency
  rate: number
  setAt: string
  /** Кто поставил курс; null — начальная запись (курс на 23.09.2026) или удалённый пользователь. */
  setBy: { id: string; name: string | null; email: string } | null
  /** Предыдущее значение этой валюты по всей истории; null — первая запись валюты. */
  prevRate: number | null
}

/** from/to — ISO; offset — сколько самых новых записей пропустить (архив). */
export async function getRateHistory(params: {
  currency?: RateCurrency
  from?: string
  to?: string
  limit?: number
  offset?: number
}): Promise<{ items: RateHistoryEntry[]; hasMore: boolean }> {
  const res = await apiClient.get<{
    success: boolean
    data: { items: RateHistoryEntry[]; hasMore: boolean }
  }>('/exchange-rates/history', { params })
  return res.data.data
}

export interface RateAt {
  rate: number
  setAt: string
}

/** Курс, действовавший в момент `at` (ISO); null — до этого момента курс не записан. */
export async function getRatesAt(at: string): Promise<Record<RateCurrency, RateAt | null>> {
  const res = await apiClient.get<{ success: boolean; data: Record<RateCurrency, RateAt | null> }>(
    '/exchange-rates/at',
    { params: { at } },
  )
  return res.data.data
}

// ── Коэффициенты наценки по матрице ──────────────────────────

export type MarkupConstants = Record<string, number>

export async function getMarkupConstants(): Promise<MarkupConstants> {
  const res = await apiClient.get<{ success: boolean; data: MarkupConstants }>('/markup-constants')
  return res.data.data
}

export async function putMarkupConstants(
  values: Partial<Record<string, number>>,
): Promise<MarkupConstants> {
  const res = await apiClient.put<{ success: boolean; data: MarkupConstants }>(
    '/markup-constants',
    values,
  )
  return res.data.data
}

/** Даты последнего обновления per-matrix. По аналогии с
 *  ExchangeRates.updatedAtByCurrency. null = значение по дефолту,
 *  записи в БД нет (никто никогда не правил эту матрицу). */
export type MarkupUpdates = Record<string, string | null>

export async function getMarkupConstantUpdates(): Promise<MarkupUpdates> {
  const res = await apiClient.get<{ success: boolean; data: MarkupUpdates }>(
    '/markup-constants/dates',
  )
  return res.data.data
}
